import { async } from "@firebase/util";
import FullTripCard from "components/TripCard/FullTripCard";
import { RootStore } from "functions/redux/store";
import { getMyTrips } from "functions/redux/transaction/action";
import React, { useState } from "react";
import Loader from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import Button from "shared/Button/Button";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ncNanoId from "utils/ncNanoId";

export const MyTrips = () => {
    const [loading, setLoading] = useState(true);
    const [loadingBtn, setLoadingBtn] = useState(false);
    const { transaction } = useSelector((state: RootStore) => state);
    const dispatch = useDispatch();
    const [page, setpage] = useState(1)
    React.useEffect(() => {
        if (transaction.myTrips == null) {
            setpage(1);
            dispatch(getMyTrips(page));
        }
        setLoading(false);

    }, [transaction, transaction.myTrips])


    const loadMore = async () => {
        setpage(page + 1)
        setLoadingBtn(true);
        if (page == 1) {
            await dispatch(getMyTrips(page + 1, transaction.myTrips));
        } else {
            await dispatch(getMyTrips(page, transaction.myTrips));
        }
        setLoadingBtn(false);
    }

    return (<>
        <div className="md:mt-2 flex space-y-4 md:space-y-0 flex-col">
            <h2 className="text-xl block md:hidden font-semibold">Your Trips</h2>

            {transaction.myTrips?.map((item: any, i: any) => (
                <FullTripCard key={ncNanoId()} trip={item} />
            ))}

        </div>
        <div className="flex mt-11 justify-center items-center">
            {loading ? <Loader
                type="Circles"
                color="#d24e29"
                height={25}
                width={25}
            /> : <></>}
        </div>
        <ButtonPrimary className="w-full" disabled={loadingBtn} onClick={() => {
            // setpage(page+1)
            loadMore()
        }}>
            {loadingBtn && (
                <Loader
                    type="Circles"
                    color="white"
                    height={20}
                    width={20}
                />
            )}
            {!loadingBtn ? <span className="pl-2">Load More</span> : <span className="pl-2">Waiting</span>}
        </ButtonPrimary>
    </>);
}